import React, { useEffect, useState } from 'react';
import { Modal, Table, Button } from 'antd';
import axios from 'axios';
import { useAuth } from '../../AuthProvider';
import { baseUrl_SPB } from '../../BaseUrl';

const columns = [
  { title: 'Number', dataIndex: 'invoiceOrQuoteNumber', key: 'invoiceOrQuoteNumber' },
  { title: 'Customer', dataIndex: 'customerName', key: 'customerName' },
  { title: 'Date', dataIndex: 'dated', key: 'dated' },
  { title: 'Total', dataIndex: 'grandTotal', key: 'grandTotal' },
];

const LinkExistingInvoiceQuoteModal = ({
  visible,
  type, // 'invoice' or 'quote'
  onSelect,
  onCancel,
}) => {
  const authContext = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    axios
      .get(`${baseUrl_SPB}/api/v1/invorquote/getinvorquote?type=${type}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authContext.token,
        },
      })
      .then((res) => {
        setData(res.data || []);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [visible, type, authContext.token]);

  return (
    <Modal
      open={visible}
      title={`Link Existing ${type === 'invoice' ? 'Invoice' : 'Quote'}`}
      onCancel={onCancel}
      onOk={() => {
        const selected = data.find((item) => item.id === selectedRowKeys[0]);
        if (selected) onSelect(selected);
      }}
      okButtonProps={{ disabled: !selectedRowKeys.length }}
      width={800}
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        rowSelection={{
          type: 'radio',
          selectedRowKeys,
          onChange: setSelectedRowKeys,
        }}
        pagination={{ pageSize: 8 }}
        size="small"
      />
    </Modal>
  );
};

export default LinkExistingInvoiceQuoteModal;
